export const GET_MESSAGES_BY_ASSIGNMENT_ID = 'GET_MESSAGES_BY_ASSIGNMENT_ID';
export const CREATE_MESSAGE = 'CREATE_MESSAGE';

export const MESSAGE_ERROR = -1;
export const MESSAGE_INIT = 1;
export const MESSAGE_SENT = 2;
export const MESSAGE_DELIVERED = 3;
